import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isNative } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    backgroundColorToken,
    backgroundColorTokenArgs,
    designContext,
    iconBackgroundColorToken,
    iconBackgroundColorTokenArgs,
    hasIcon,
    leftIcon,
    rightIcon,
    shouldTruncateTitle,
    shouldTruncateSubtitle,
    textColorToken,
    textColorTokenArgs,
    title,
    height = 60,
    alignTitle = 'center'
  } = _ref;
  var borderRadius = designContext.get('navbar/corner-radius').value();
  var iconBackgroundColor = iconBackgroundColorToken ? designContext.get(iconBackgroundColorToken, iconBackgroundColorTokenArgs).toString() : designContext.get('navbar/background-color').toString();
  var innerHeight = 60;
  return {
    rootStyle: _objectSpread(_objectSpread({}, backgroundColorToken ? {
      backgroundColor: designContext.get(backgroundColorToken, backgroundColorTokenArgs).toString()
    } : {
      backgroundColor: designContext.get('navbar/background-color').toString()
    }), {}, {
      flexDirection: 'row',
      justifyContent: 'center',
      height,
      position: 'relative',
      width: '100%'
    }),
    leftWrapperStyle: {
      justifyContent: 'center',
      height: innerHeight,
      left: 0,
      paddingLeft: 20,
      position: 'absolute'
    },
    leftActionStyle: {
      marginLeft: -10,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    leftIconStyle: iconBackgroundColorToken ? {
      marginLeft: -10,
      width: 40,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius,
      backgroundColor: iconBackgroundColor
    } : {},
    textWrapperStyle: {
      alignItems: 'center',
      height,
      justifyContent: alignTitle,
      paddingLeft: hasIcon ? 20 : Boolean(leftIcon) || Boolean(rightIcon) ? 60 : 20,
      paddingRight: hasIcon ? 20 : Boolean(leftIcon) || Boolean(rightIcon) ? 60 : 20,
      maxWidth: '100%',
      zIndex: -99
    },
    textInnerWrapperStyle: {
      height: innerHeight,
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '100%'
    },
    titleStyle: {
      flexDirection: 'row',
      maxWidth: '100%'
    },
    titleSecondaryStyle: _objectSpread(_objectSpread(_objectSpread({
      color: textColorToken ? designContext.get(textColorToken, textColorTokenArgs).toString() : designContext.get('navbar/title-text-color').toString()
    }, designContext.get('navbar/title-text-style').styles()), {}, {
      textAlign: 'left',
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-all'
    }, shouldTruncateTitle && _objectSpread(_objectSpread({}, isNative ? {} : {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1
    }), {}, {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    })), {}, {
      marginBottom: 0,
      marginTop: 1
    }),
    subtitleStyle: {
      marginTop: title ? 2 : 0
    },
    klarnaLogoStyle: {
      alignItems: 'center',
      height,
      justifyContent: alignTitle,
      opacity: 1
    },
    rightWrapperStyle: {
      justifyContent: 'center',
      height: innerHeight,
      paddingRight: 20,
      position: 'absolute',
      right: 0
    },
    rightActionStyle: {
      marginRight: -10,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    rightIconStyle: iconBackgroundColorToken ? {
      marginRight: -10,
      width: 40,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius,
      backgroundColor: iconBackgroundColor
    } : {},
    paragraphSecondaryStyle: _objectSpread(_objectSpread({
      color: designContext.get('navbar/title-text-color').toString()
    }, designContext.get('navbar/subtitle-text-style').styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-all',
      marginBottom: 0,
      marginTop: 0
    }, shouldTruncateSubtitle && _objectSpread(_objectSpread({}, isNative ? {} : {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1
    }), {}, {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }))
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map